export const AUTHENTICATION_STORAGE_KEY = 'authentication-storage-key' as const;
export const TOKEN_KEY = `${AUTHENTICATION_STORAGE_KEY}-token` as const;
